<template>
    <div> 
        <v-toolbar :height="height?height:'52'"  
            @click="ON_SEARCH(pricing_tier)" :rounded="rounded" dark flat 
            :color="LocalCashup?'primary':'grey darken-1'" 
            class="pa-0">
            <v-layout justify-center align-center>
                <v-menu  
                    v-model="menu_search_model"
                    :close-on-content-click="true" 
                    offset-y  offset-overflow
                    :nudge-width="90" rounded="xl"
                    > 
                    <template v-slot:activator="{ on, attrs }">   
                        <v-autocomplete class="mr-2 mt-1"
                            @click="ON_SEARCH(pricing_tier)"
                            ref="ref_search_item"
                            v-model="search_item"
                            :search-input.sync="search_text"
                            :disabled="inputLoading || !LocalCashup|| !pricing_tier"
                            :items="ItemsFiltered" dense
                            :append-icon="search_model?search_model.icon:'search'"
                            :prepend-inner-icon="vs.smAndDown?(search_model?search_model.icon:'search'):''"
                            outlined :rounded="false"
                            :label="pricing_tier?'Search for Item':'You Must Pricing Tier First'"
                            color="blue-grey lighten-2" 
                            item-text="name"
                            item-value="key" 
                            :filter="(item, queryText, itemText) => { 
                                let index = (a,b)=>{
                                        if(!a||!b){return false}
                                        a = ''+a; b = ''+b
                                        return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                                    } 
                                    let first = index(itemText,queryText)
                                    let second = item?index(item?.code,queryText):false
                                    let third = item?index(item?.brand_name,queryText):false
                                    let forth = item?index(item?.category_name,queryText):false
                                    let fifth = item?item?.special_code == queryText:false
                                    let all = first || second || third || forth  || fifth 
                                    if(!item){return first}  
                                    if (search_model?.code == 2) {
                                        return first
                                    }else if (search_model?.code == 3) {
                                        return second || third
                                    }else if (search_model?.code == 4) {
                                        return forth
                                    }else if (search_model?.code == 5) {
                                        return fifth
                                    }
                                    return all
                            }"
                            >
                            <template v-slot:selection="data">
                                {{ data.item.name }} 
                            </template>
                            <template v-slot:item="data">
                                <template v-if="(typeof data.item !=='object')" >
                                    <v-list-item-content v-text="data.item"></v-list-item-content>
                                </template>
                                <template v-else>
                                    <v-list-item-avatar tile color="grey" >
                                        <img :src="data.item.image" v-if="data.item.image">
                                        <v-icon v-else>local_offer</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content >
                                        <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                        <v-list-item-subtitle v-html="data.item.code_"></v-list-item-subtitle>
                                        <v-list-item-subtitle v-html="data.item.category_name"></v-list-item-subtitle>
                                        <v-list-item-subtitle v-html="data.item.brand_name"></v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action v-if="pricing_tier">
                                        <div> 
                                            <small>MWK</small> {{ MBS.actions.money(data.item[pricing_tier.key+"_"]) }}
                                        </div>
                                        <!-- <div> 
                                            <small>Stock</small> {{ data.item[CurrentOutlet.key+"_number_quantity"] }}
                                        </div> -->
                                    </v-list-item-action> 
                                </template>
                            </template>
                            <template v-slot:append v-if="vs.smAndDown">
                                <v-btn @click="ON_ITEM_ACTION" style="top: -4px; right: -8px;" min-width="38"  class="ma-0 px-0" color="b2">
                                    <v-icon color="primary">mdi-view-grid-outline</v-icon>
                                </v-btn>
                            </template> 
                        </v-autocomplete> 
                    </template> 

                    <v-card  v-if="ud"  
                        color="lighten-1" class="">  
                        <v-card-title class="secondary white--text py-" dark>
                            Search Model
                            <v-spacer></v-spacer>
                            <v-btn @click="menu_search_model=false" dark icon><v-icon>close</v-icon></v-btn>
                        </v-card-title> 
                        <v-list dense> 
                            <div v-for="(model,index) in search_model_option" :key="index">
                                <v-list-item 
                                    :class="model?.code == search_model?.code?'secondary--text':''" 
                                    @click="search_model=model">
                                    <v-list-item-icon><v-icon>{{model?model.icon:'mdi-magnify'}}</v-icon></v-list-item-icon>
                                    <v-list-item-content>{{model?model.name:'...'}}</v-list-item-content> 
                                </v-list-item> 
                            </div>
                        </v-list>  
                    </v-card>  
                </v-menu>  
                 

                <!-- //IF CARD -->
                <v-menu   v-if="selected_card"
                    v-model="menu_selected_card"
                    :close-on-content-click="true" 
                    offset-y  offset-overflow
                    :nudge-width="90" rounded="xl"
                    >
                    <template v-slot:activator="{ on, attrs }" >   
                        <v-btn  v-on="on" outlined class="mr-2 mb-1 pr-0"  > 
                            <v-icon>mdi-credit-card-scan </v-icon>
                            <v-icon class="ml-2 ">arrow_drop_down</v-icon>
                        </v-btn>  
                    </template> 

                    <v-card  v-if="ud"  
                        color="lighten-1" class="">  
                        <v-card-title class="secondary white--text py-" dark>
                            Selected Card
                        </v-card-title> 
                        <v-list dense> 
                            <div v-if="selected_card">
                                <v-list-item>Card Holder: {{selected_card.customer_name}}</v-list-item> 
                                <v-list-item>Card Number: {{selected_card?.code}}</v-list-item> 
                                <v-list-item>Expire Date: {{selected_card.card_expire_date}}</v-list-item> 
                                <v-list-item>Balance: MWK{{MBS.actions.money(selected_card.balance_amount)}}</v-list-item> 
                            </div>
                            <v-divider /> 
                            <v-list-item :class="'secondary--text text-center'" @click="DESELECT_CARD">
                                <v-layout justify-center>
                                    Clear
                                </v-layout>
                            </v-list-item> 
                        </v-list>  
                    </v-card>  
                </v-menu>  
                
                <!-- //IF ORDER -->
                <v-menu   v-if="item_order"
                    v-model="menu_item_order"
                    :close-on-content-click="true" 
                    offset-y  offset-overflow
                    :nudge-width="90" rounded="xl"
                    >
                    <template v-slot:activator="{ on, attrs }" >   
                        <v-btn  v-on="on" outlined class="mr-2 mb-1 pr-0"  > 
                            <span v-if="item_order?.order_type =='quotation'">
                                <v-icon v-if="edit_order_items">mdi-text-box-edit</v-icon>
                                <v-icon v-else>mdi-text-box</v-icon> 
                            </span>
                            <span v-else>
                                <v-icon v-if="edit_order_items">mdi-square-edit-outline</v-icon>
                                <v-icon v-else>mdi-cart</v-icon> 
                            </span>
                            <v-icon class="ml-2 ">arrow_drop_down</v-icon>
                        </v-btn>  
                    </template> 

                    <v-card  v-if="ud"  
                        color="lighten-1" class="">  
                        <v-card-title class="secondary white--text py-" dark>
                            Selected Order Options 
                        </v-card-title> 
                        <v-list dense>  
                            <v-list-item v-if="item_order?.order_type !='quotation' && edit_order_items" @click="edit_order_items=false">
                                <v-list-item-action><v-icon>mdi-pencil-off-outline</v-icon></v-list-item-action> 
                                <v-list-item-content>Cancel Order Editing</v-list-item-content> 
                            </v-list-item> 
                            <v-list-item v-if="!edit_order_items" @click="CONFIRM_EDIT_ORDER_ITEMS(item_order)">
                                <v-list-item-action><v-icon>edit</v-icon></v-list-item-action> 
                                <v-list-item-content>Edit Order</v-list-item-content> 
                            </v-list-item>  
                            <v-list-item v-if="item_order?.order_type !='quotation'" @click="PRINT_ITEM_ORDERS({
                                order:item_order
                            })">
                                <v-list-item-action><v-icon>print</v-icon></v-list-item-action> 
                                <v-list-item-content>Print Order</v-list-item-content> 
                            </v-list-item>  
                            <v-list-item v-if="item_order?.order_type !='quotation'" @click="CONFIRM_DELETE_ITEM_ORDER({
                                order:item_order,
                                deleting_reason:'user_delete',
                                notify:true
                            })">
                                <v-list-item-action><v-icon>mdi-delete</v-icon></v-list-item-action> 
                                <v-list-item-content>Delete Order</v-list-item-content> 
                            </v-list-item> 
                            <v-divider/> 
                            <v-list-item v-if="item_order?.order_type !='quotation'" :class="'secondary--text text-center'" @click="CLEAR_ALL_DATA()">
                                <v-layout justify-center>
                                    Deselect Order
                                </v-layout>
                            </v-list-item> 
                            <v-list-item v-if="item_order?.order_type =='quotation'" :class="'secondary--text text-center'" @click="CLEAR_ALL_DATA()">
                                <v-layout justify-center>
                                    Deselect Quotation
                                </v-layout>
                            </v-list-item> 
                        </v-list>  
                    </v-card>  
                </v-menu>  
                
                <v-menu  
                    v-model="menu_pricing_tier"
                    :close-on-content-click="true" 
                    offset-y  offset-overflow
                    :nudge-width="90" rounded="xl"
                    >
                    <!-- :disabled="CompanySettings?CompanySettings.only_retail_model||CompanySettings.only_wholesale_model:false"   -->
                    <template v-slot:activator="{ on, attrs }">  
                        <v-btn :small="vs.smAndDown" height="38"  v-on="on" class=" m-1"
                            ref="btn_selling_mode"
                                color="secondary">
                            {{pricing_tier?pricing_tier.name:'Select'}}
                            <v-icon class="ml-2">arrow_drop_down</v-icon>
                        </v-btn> 
                    </template> 

                    <v-card  v-if="ud"  
                        color="lighten-1" class="">  
                        <v-card-title class="secondary white--text py-" dark>
                            Select Pricing Tier 
                        </v-card-title> 
                        <v-list dense> 
                            <div v-for="(pricing,index) in TillPricingTiers" :key="index">
                                <v-list-item 
                                    :class="pricing == pricing_tier?'secondary--text':''" 
                                    @click="pricing_tier=pricing">
                                    {{pricing?pricing.name:'...'}}
                                </v-list-item> 
                            </div>
                        </v-list>  
                    </v-card>  
                </v-menu>   
            </v-layout>
        </v-toolbar>   
    </div>
</template> 
<script> 

    import DATA from "../../../plugins/DATA";
    import {mapState} from "vuex"   
    
    const PAGE_NAME = "SALE-SEARCH"

    export default {
        props:['height','selected_card','item_order','rounded'],
        data(){
            return{
                show:false,     
                inputLoading:false,     
                menu_pricing_tier:false,  
                menu_search_model:false,  
                menu_item_order:false, 
                edit_order_items:false, 
                pricing_tier:null,
                search_item:null,
                search_text:null,
                search_model:null,
                search_model_option:[
                   {code:1, icon:"mdi-magnify", name:"All *"},
                   {code:2, icon:"mdi-tag-search", name:"Search by Name"},
                   {code:3, icon:"mdi-barcode-scan", name:"Search by Barcode"},
                   {code:4, icon:"mdi-table-search", name:"Search by Category"},
                   {code:5, icon:"mdi-selection-search", name:"Search Special Code"},
                ]

            }
        },
        created(){ 
            try { 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted(){  
            this.INITIALIZE_PRICING_TIER()
        },
        computed:{
            vs(){
                let vs = this.$vuetify.breakpoint 
                return vs
            }, 
            vs_width(){
                let vs = this.vs
                if(!vs){return null}
                return vs.width
            },
            vsh(){
                return this.vs.height
            },
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
                tus: state=> state.users["TEMPORARY_USER"], 
                SELECTED_COMPANY: state=> state.items['SELECTED_COMPANY'],
                K_CONNECTOR: state=> state.items['K_CONNECTOR'],
                CompanySettings: state=> state.items[(DATA.ITEMS.COMPANY_SETTINGS.values).toUpperCase()], 
            }),
            ...mapState({
                CompanyQuickActions: state=> state.items[(DATA.ITEMS.COMPANY_QUICK_ACTIONS.values).toUpperCase()], 
                Items: state=> state.items[(DATA.ITEMS.ITEMS.values).toUpperCase()],
                JoinedItems: state=> state.join[(DATA.ITEMS.ITEMS.values).toUpperCase()], 
                ItemCategories: state=> state.items[(DATA.ITEMS.ITEM_CATEGORIES.values).toUpperCase()],
                ItemDepartments: state=> state.items[(DATA.ITEMS.ITEM_DEPARTMENTS.values).toUpperCase()],
                Tills: state=> state.items[(DATA.ITEMS.TILLS.values).toUpperCase()],
                JoinedTills: state=> state.join[(DATA.ITEMS.TILLS.values).toUpperCase()], 

                LocalCashups: state=> state.locals[(DATA.ITEMS.LOCAL_CASHUPS.values).toUpperCase()],
                
            }), 
            ItemsData(){
                const settings = this.CompanySettings
                const eis = settings?.eis
                const Items = this.Items
                const JoinedItems = this.JoinedItems  
                const item = JoinedItems?JoinedItems:Items
                const filter = item?.filter(item=>{
                    if (eis) {
                        return item.is_mra_verified && item.item_type_key!="raw_material"
                    }
                    return item.item_type_key!="raw_material"
                })
                return filter
            }, 
            ItemsFiltered(){
                const items = this.ItemsData
                const departments = this.selected_departments
                const categories = this.FilteredItemCategories 
                if(!items){return null}
                if(!this.MBS.actions.SIZE(departments)){return items}
                let filtered = items.filter(item=>{
                    let index = departments?departments.indexOf(item.item_department_code):0
                    let index2 = categories?categories.findIndex(category=>category?.code == item.category_code):0
                    return (index!=-1)||(index2!=-1)
                })
                return filtered

            }, 
            TillsData(){
                return this.JoinedTills?this.JoinedTills:this.Tills
            }, 
            CurrentTill(){
                let tills = this.TillsData
                let cashup = this.LocalCashup  
                if(!tills || !cashup){return null}
                let filled = tills.find(item=>{
                    return item.key == cashup.till_key
                })   
                return filled
            },

            LocalCashup(){    
                let cashups = this.LocalCashups 
                let local_cashup = cashups?cashups.find(item=>{
                    return !item.closed
                }):null 
                this.day_shift_key = local_cashup?.day_shift_key 
                return local_cashup
            }, 
           
            AssignedPrinter(){
                let till = this.CurrentTill 
                let old_printer = till?till.printer:null
                let assigned_printers = this.MBS.actions.JOIN_PRINTERS(till?till.assigned_printers:null) 
                return (payload)=>{ 
                    const  legal  = payload?.legal
                    const  drawer  = payload?.drawer
                    const  document  = payload?.document 
                    if(!assigned_printers){return old_printer}
                    let printers = [...assigned_printers]
                    const doc_type = document?.doc_type
                    const order = document?.order
                    const departments = order?.joined_items_departments

                    printers.sort(this.MBS.actions.dynamicSort("printer_priority",true))  
                    

                    if (this.MBS.actions.SIZE(departments)) {
                        printers=printers.filter(item=>{
                            if (!this.MBS.actions.SIZE(item.department_codes)||item.department_codes.indexOf('all')!=-1) {
                                return true
                            }
                            const index = departments.findIndex(depart=>item.department_codes.indexOf(depart?.code)!=-1)
                            return index==-1?false:true
                        }) 
                        console.log(printers,"printers-dep-------");
                    }
 
                    
                    if (legal) {
                        printers = printers.filter(printer=>
                            printer.printer_option=='print_legal_receipt'||
                            printer.printer_option=='print_all'
                        ) 
                        console.log('111-----------------');
                        
                    }else { 
                        if (doc_type=="bill") {
                            printers = printers.filter(printer=>
                                printer.printer_option=='print_bill'|| 
                                printer.printer_option=='print_nonlegal_receipt'||
                                printer.printer_option=='print_all' 
                            )  
                            // printers.sort(this.MBS.actions.dynamicSort("printer_option",true)) 
                            console.log('222-----------------');
                        } else if (doc_type=="docket") {
                            printers = printers.filter(printer=>
                                printer.printer_option=='print_docket'|| 
                                printer.printer_option=='print_nonlegal_receipt'||
                                printer.printer_option=='print_all' 
                            )  
                            // printers.sort(this.MBS.actions.dynamicSort("printer_option",false)) 
                            console.log('333-----------------');
                        } else {
                            printers = printers.filter(printer=>printer.printer_option!='print_legal_receipt' )  
                        }
                    }  
                    if (drawer==true) {
                        printers = printers.filter(printer=>printer.connect_cash_drawer) 
                        console.log('5555-----------------');
                    } 
                    return printers[0]
                }
            },
            AllowChangingDepartments(){
                const till = this.CurrentTill
                const change = till?till.allow_Cashier_to_change_department:false 
                return change 
            },
            ActionTypesDisabled(){   
                let localCashup = this.LocalCashup
                if (localCashup) {
                    return null
                }
                return  ["sales",]
            }, 
            TillPricingTiers(){
                let till = this.CurrentTill 
                let pricing_tiers = till?till.pricing_tiers:null 
                return pricing_tiers
            },

             
        },
        methods:{ 
            INITIALIZE_PRICING_TIER(){
                try {
                    let pricing_tiers = this.TillPricingTiers
                    if (!pricing_tiers) {
                        
                    } else {
                        this.pricing_tier = pricing_tiers[0]
                    }
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'INITIALIZE_PRICING_TIER',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            ON_SEARCH(pricing_tier){
                try {    
                    if (!pricing_tier) { 
                        this.menu_pricing_tier = true
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_SEARCH',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            ON_ITEM_ACTION(value){
                try {    
                    this.MBS.events.$emit("ON_ITEM_ACTION",value)
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_ITEM_ACTION',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            SELECT_SEARCH_MODEL(model){
                this.search_model = model
            },
            CONFIRM_EDIT_ORDER_ITEMS(order){
                let mbs_text = this.MBS.text.item_action("Issued Order.","Edit")
                    this.MBS.actions.dialogConfirmPassword({
                        show:true,
                        fixed:true,
                        icon:"mdi-shield-lock-outline",
                        title:mbs_text.title,
                        text:mbs_text.text+" Enter your password to confirm.",
                        action:{
                            code:"SALE=EDIT-ORDER-ITEMS", 
                            data:order,
                            phone_number_start:true,
                            all_users:true, 
                            get_access:{
                                permission_type:"option", 
                                action_name:"Edit Sale Order"  
                            }
                        }
                    }) 
            },



            //---------------[MAIN FUNCTIONS]------------   
             

        },
        beforeDestroy(){
            try {
                this.MBS.events.$off('ON_QR_SCAN', this.ON_QR_SCAN);  
                this.MBS.events.$off('MBS_KEYBOARD', this.MBS_KEYBOARD);      
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'beforeDestroy',
                    page:PAGE_NAME, 
                })
            }
        },
        watch:{ 
            search_item(value){
                if(value){
                    console.log(this.search_item,'-------------');
                    
                    setTimeout(() => {
                        this.search_item=null 
                    }, 500);
                    this.$emit("on_search_item",value)
                } 
            }, 
            search_text(value){
                if(value == "..."){
                    console.log(value,'-------------tttt'); 
                    this.menu_search_model = true
                    this.search_text = ""
                    
                } 
            }, 
            click_mode(value){
                this.$emit("on_click_mode",value)
            },
            pricing_tier(value){
                this.$emit("on_pricing_tier",value)
            },
            CurrentTill(actions){ 
                this.INITIALIZE_PRICING_TIER()  
            }, 
             
            
        } 

    }
</script>
<style>
    .selected {
        background-color: #a8dadc;
    }
    .checked {
        background-color: #dadada;
    }
    
</style> 